export var AllApplicationsActions;
(function (AllApplicationsActions) {
    AllApplicationsActions[AllApplicationsActions["DisallowChangeRegNumber"] = 0] = "DisallowChangeRegNumber";
})(AllApplicationsActions || (AllApplicationsActions = {}));
//# sourceMappingURL=types.js.map